import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal__parking-spots-template-wrapper" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "modal__parking-spots-box" }
const _hoisted_5 = { class: "modal__subtitle" }
const _hoisted_6 = { class: "modal__parking-spots-list" }
const _hoisted_7 = { class: "modal__parking-spots-number" }
const _hoisted_8 = {
  key: 1,
  class: "modal__parking-spots-free-box"
}
const _hoisted_9 = { class: "modal__subtitle" }
const _hoisted_10 = { class: "modal__parking-spots-list" }
const _hoisted_11 = { class: "modal__parking-spots-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.descriptionTop)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal__description",
            innerHTML: _ctx.descriptionTop
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_translated_text_component, { translation: "modal_parking_spaces_amount" })
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parkingSpotsItems, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.category,
              class: "modal__parking-spots-item"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([[
                  '--category-'+item.category,
                  item.category == 'DISABLED' ? 'icomoon-park_dis': 'icomoon-park_car',
                ], "modal__parking-spots-icon"])
              }, null, 2),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.spots), 1)
            ]))
          }), 128))
        ])
      ]),
      (_ctx.parkingFreeSpotsItems.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_translated_text_component, { translation: "modal_parking_free_spaces_amount" })
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parkingFreeSpotsItems, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.category,
                  class: _normalizeClass([_ctx.getStatusClassName(item.free), "modal__parking-spots-item"])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass([[
                  '--category-'+item.category,
                  item.category == 'DISABLED' ? 'icomoon-park_dis': 'icomoon-park_car',
                ], "modal__parking-spots-icon"])
                  }, null, 2),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.free), 1)
                ], 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}